import { Injectable } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { ApplicationConfig } from '../../config/config';
import { FlyoutExternalsiteComponent } from '../../flyout/flyout-externalsite/flyout-externalsite.component';
import { ContentAccessibilityPopup } from '../../model/content/contentAccessibilityPopup.model';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class FlyoutExternalSiteService {
  axPopupContent: ContentAccessibilityPopup;
  modalOnHiddenSubscription: Subscription;
  modalConfig = {
    animated: false
  };

  public reqActiveEle: any;
  public enableDragModal = true;
  focusableEls: any = [];
  firstFocusableEl: any = [];
  lastFocusableEl: any = [];
  lightFooter: boolean;
  shopHeader: boolean;
  isShoppingHeader: boolean;
  flyOutPositionHeight: any;
  flyoutFeedHeaderPosition: any;
  flyOutLocation: any;
  loginSessionRefreshVal: boolean;
  deepLinkVendorId = '';

  constructor(
    private config: ApplicationConfig,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    private commonService: CommonService,
    private loggingService: LoggingService
  ) {}

  openFlyoutExtSiteModal(hrefUrl, ele, rendr) {
    const bodyScroll = document.documentElement.scrollTop;
    this.modalOnHiddenSubscription = this.modalService.onHidden.subscribe(
      (reason: string) => {
        this.modalOnHiddenSubscription.unsubscribe();
      },
      (err) => {
        if (this.config.onBrowser) {
          this.loggingService.log('Caught Error: ' + err);
        }
      }
    );
    let obj;
    obj = Object.assign({}, this.modalConfig, {
      class: 'dl-modal extsite-dialog'
    });
    this.bsModalRef = this.modalService.show(FlyoutExternalsiteComponent, obj);
    this.bsModalRef.content.hrefUrl = hrefUrl;
    this.bsModalRef.content.axPopupContent =
      this.commonService.getAxPopupContent();
    this.bsModalRef.content.dialog.nativeElement.focus();
    // Add class extsite-modal-container to modal-container tag
    const extModal = document.querySelector('.extsite-dialog')
      ? document.querySelector('.extsite-dialog').parentNode
      : null;
    if (extModal) {
      rendr.addClass(extModal, 'extsite-modal-container');
    }
    const htmlRoot = document.getElementsByTagName('html')[0];
    if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
      htmlRoot.className += ' no-scroll';
    }
    this.commonService.dragModalContainers(ele, rendr);
    document.documentElement.scrollTop = bodyScroll;
    this.commonService.focusModalContainers(ele, rendr);
  }
}
